export const HomeTerminalTranslationsDictionary = {
    HomeTerminal: "Home terminal",
    HomeTerminalAddress: "Home terminal address",
    SaveChanges: "Save",
    Cancel: "Cancel",
    SuccessMessage: "Home terminal successfully changed",
    OfflineError: "You cannot change your home terminal while offline.",
    ErrorMessage: "Failed to save changes. Please try again."
};

let getTranslations = () => {
    let r: string[] = [];
    for (const prop in HomeTerminalTranslationsDictionary) {
        r.push(HomeTerminalTranslationsDictionary[prop]);
    }
    return r;
};

export const HomeTerminalTranslations = getTranslations();
